import {create} from "zustand";

export const useFindOutYourSizeStore = create((set) => ({
    // Модальное окно "Узнать свой размер"
    findOutYourSizeFlag: false,

    /**
     * Модальное окно "Узнать свой размер"
     */
    openModalFindOutYourSize: () => set({findOutYourSizeFlag: true}),

    /**
     * Модальное окно "Узнать свой размер"
     */
    closeModalFindOutYourSize: () => set({findOutYourSizeFlag: false}),
}));
